import { render } from "./IssuedOutUnitsTab.vue?vue&type=template&id=6cd48aee"
import script from "./IssuedOutUnitsTab.vue?vue&type=script&lang=js"
export * from "./IssuedOutUnitsTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__